import { useDialogContext } from '../contexts/DialogContext';
import { DialogOptions, DialogVariant } from '../components/ui/Dialog';

export interface UseDialogReturn {
  showDialog: (options: DialogOptions) => void;
  showAlert: (title: string, message: string, variant?: DialogVariant) => Promise<void>;
  showConfirm: (title: string, message: string, variant?: DialogVariant) => Promise<boolean>;
  showSuccess: (title: string, message: string) => Promise<void>;
  showError: (title: string, message: string) => Promise<void>;
  showWarning: (title: string, message: string) => Promise<void>;
  showInfo: (title: string, message: string) => Promise<void>;
  closeDialog: () => void;
}

export const useDialog = (): UseDialogReturn => {
  const { showDialog, showAlert, showConfirm, closeDialog } = useDialogContext();

  const showSuccess = (title: string, message: string) => {
    return showAlert(title, message, 'success');
  };

  const showError = (title: string, message: string) => {
    return showAlert(title, message, 'error');
  };

  const showWarning = (title: string, message: string) => {
    return showAlert(title, message, 'warning');
  };

  const showInfo = (title: string, message: string) => {
    return showAlert(title, message, 'info');
  };

  return {
    showDialog,
    showAlert,
    showConfirm,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    closeDialog,
  };
};

export default useDialog;
